import { CustomSelectFieldProps, SelectField } from 'components/form'
import { StatusVacinacaoEnum } from 'graphql/types.generated'

export interface StatusDoseImunoSelectModel {
  id: ID
  enum: StatusVacinacaoEnum
  descricao: string
}

type StatusDoseImunoSelectFieldProps = CustomSelectFieldProps<StatusDoseImunoSelectModel> & {
  items?: StatusDoseImunoSelectModel[]
  isTipoBuscaAtivaCovid: boolean
}

const itemToString = (item: StatusDoseImunoSelectModel) => item?.descricao

export function StatusDoseImunoSelectField(props: StatusDoseImunoSelectFieldProps) {
  const { items: itemsExterno, isTipoBuscaAtivaCovid: isTipoAcompanhamentoCovid, ...rest } = props

  return (
    <SelectField<StatusDoseImunoSelectModel>
      items={itemsExterno ?? Object.values(items)}
      itemToString={itemToString}
      required
      {...rest}
    />
  )
}

export const items: Record<StatusVacinacaoEnum, StatusDoseImunoSelectModel> = {
  [StatusVacinacaoEnum.ATRASADA]: {
    id: 1,
    enum: StatusVacinacaoEnum.ATRASADA,
    descricao: 'Atrasada',
  },
  [StatusVacinacaoEnum.NO_PRAZO]: {
    id: 2,
    enum: StatusVacinacaoEnum.NO_PRAZO,
    descricao: 'No prazo',
  },
  [StatusVacinacaoEnum.APLICADA]: {
    id: 3,
    enum: StatusVacinacaoEnum.APLICADA,
    descricao: 'Aplicada',
  },
}
